<render-component [page]=page [pageComponents]=homeContent.page_components></render-component>